import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asignacion-menu',
  templateUrl: './asignacion-menu.component.html',
  styleUrls: ['./asignacion-menu.component.scss'],
})
export class AsignacionMenuComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
